import { Typography } from 'antd';
import type { ReactNode } from 'react';

interface Props {
  title: string;
  labelClass?: string;
  textClass?: string;
  childClassName?: string;
  children?: ReactNode;
}

const FiledCard = ({ title, children, labelClass, textClass, childClassName }: Props) => {
  return (
    <div className={`field-card-container ${textClass ?? ''}`}>
      <Typography.Text className={`field-card-title ${labelClass ?? ''}`}>{title}</Typography.Text>
      {children && <div className={`content ${childClassName ?? ''}`}>{children}</div>}
    </div>
  );
};

export default FiledCard;
